"use strict";

import angular from "angular";

import template from "./popover.component.html";
import "./popover.component.scss";

class PopoverComponent {
    constructor() {
        this.opened = false;
    }

    $onInit() {}

    $onChanges(changes) {
        if (typeof changes.togglePopOver.previousValue != "object")
            this.toggle();
    }

    toggle() {
        this.opened = !this.opened;
        this.onToggle({ opened: this.opened });
    }
}

PopoverComponent.$inject = [];

const component = {
    bindings: {
        onToggle: "&",
        togglePopOver: "<",
        alignRight: "<"
    },
    transclude: {
        popOverButton: "popOverButton",
        popOverContent: "popOverContent"
    },
    controller: PopoverComponent
};

const name = "popoverComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
